import { render, staticRenderFns } from "./JobDescriptionCard.vue?vue&type=template&id=a9bc3d58&scoped=true&"
import script from "./JobDescriptionCard.vue?vue&type=script&lang=js&"
export * from "./JobDescriptionCard.vue?vue&type=script&lang=js&"
import style0 from "./JobDescriptionCard.vue?vue&type=style&index=0&id=a9bc3d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bc3d58",
  null
  
)

export default component.exports